import { Admin } from 'react-admin';
import React from 'react';
import esLocale from 'date-fns/locale/es';
import { createBrowserHistory } from 'history';
import { RbacResource as Resource } from '@blackbox-vision/ra-rbac';

import { theme } from './core/theming';

import { i18nProvider } from './core/providers/i18n';
import { authProvider } from './core/providers/auth';
import { dataProvider } from './core/providers/data';

import { canActivate } from './core/helpers/canActivate';

import AppLayout from './components/templates/app-layout';
import AppProvider from './components/templates/app-provider';

import CustomLogin from './pages/auth';

import usersResourceProps from './pages/users';
import currenciesResourceProps from './pages/currencies';
import investmentsResourceProps from './pages/investments';
import transactionsResourceProps from './pages/transactions';
import interestsResourceProps from './pages/interests';
import settingsResourceProps from './pages/settings';
import metricsResourceProps from './pages/metrics';
import holdingsResourceProps from './pages/holdings';

// La portada de la consola. Va como `dashboard` para quedarse con la ruta `/`.
let Hoy = React.lazy(() => import(/* webpackChunkName: "c-hoy" */ './console/pages/hoy'));

let browserHistory = createBrowserHistory();

let App = () => {
  return (
    <AppProvider
      theme={theme}
      locale={esLocale}
      canActivate={canActivate}
    >
      <Admin
        disableTelemetry
        theme={theme}
        layout={AppLayout}
        dashboard={Hoy}
        loginPage={CustomLogin}
        history={browserHistory}
        i18nProvider={i18nProvider}
        dataProvider={dataProvider}
        authProvider={authProvider}
      >
        <Resource {...usersResourceProps} />
        <Resource {...currenciesResourceProps} />
        <Resource {...investmentsResourceProps} />
        <Resource {...transactionsResourceProps} />
        <Resource {...interestsResourceProps} />
        <Resource {...metricsResourceProps} />
        <Resource {...holdingsResourceProps} />
        <Resource {...settingsResourceProps} />
      </Admin>
    </AppProvider>
  );
};

export default App;
